import MuiChip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const Chip = ({ label, gradientFrom, gradientTo, sx, ...props }) => {
    const theme = useTheme();

    const from = gradientFrom || theme.palette.primary.main;
    const to = gradientTo || theme.palette.secondary.main;

    const defaultStyle = {
        background: `linear-gradient(45deg, ${from}, ${to})`,
        color: 'white',
        fontSize: '1.5rem',
        px: 4,
        py: 3,
        fontWeight: 600,
    };

    return <MuiChip label={label} sx={{ ...defaultStyle, ...sx }} {...props} />;
};

Chip.propTypes = {
    label: PropTypes.node,
    gradient: PropTypes.bool,
    gradientFrom: PropTypes.string,
    gradientTo: PropTypes.string,
    sx: PropTypes.object,
};

export default Chip;
